import { render } from "./GalleryEmptyState.vue?vue&type=template&id=340bc5d1&scoped=true"
import script from "./GalleryEmptyState.vue?vue&type=script&lang=js"
export * from "./GalleryEmptyState.vue?vue&type=script&lang=js"

import "./GalleryEmptyState.vue?vue&type=style&index=0&id=340bc5d1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340bc5d1"]])

export default __exports__